import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import { API } from "../lib/api";

const LEGAL_FALLBACK = {
  terms: {
    title: "Website Terms",
    tagline: "Last updated: October 2026",
    sections: [
      { heading: "1. Scope", text: "These terms apply to simplyowner.com and the simplyOwner shop system. Using the site or requesting a demo means you accept them." },
      { heading: "2. The product", text: "simplyOwner is a one-time shop, website and apps package for hospitality and local retail. Pricing on the site is indicative until a written offer is confirmed." },
      { heading: "3. Contact", text: "Questions: hello@simplyowner.com" },
    ],
  },
  privacy: {
    title: "Privacy Policy",
    tagline: "Last updated: October 2026",
    sections: [
      { heading: "1. Data we collect", text: "We collect the contact details, business information and files you send when you request a demo or become an owner. Your shop's customer data belongs to you." },
      { heading: "2. How we use it", text: "Your data is used to build, host and support your shop system. We never sell data to marketplaces or advertisers." },
      { heading: "3. Your rights", text: "You can request access, correction or deletion at any time via hello@simplyowner.com." },
    ],
  },
  impressum: {
    title: "Impressum",
    tagline: "Legal notice",
    sections: [
      { heading: "Company", text: "simplyOwner\nSwitzerland" },
      { heading: "Contact", text: "Email: hello@simplyowner.com\nSupport: 24/7, in 7 languages." },
    ],
  },
};

export default function TermsPage({ slug = "terms" }) {
  const [page, setPage] = useState(LEGAL_FALLBACK[slug] || LEGAL_FALLBACK.terms);

  useEffect(() => {
    window.scrollTo(0, 0);
    setPage(LEGAL_FALLBACK[slug] || LEGAL_FALLBACK.terms);
    axios.get(`${API}/pages/${slug}`).then((r) => setPage(r.data)).catch(() => {});
  }, [slug]);

  return (
    <main data-testid="terms-page" className="relative">
      <Header />
      <section className="max-w-3xl mx-auto px-6 lg:px-12 pt-40 pb-28">
        {!page ? (
          <div className="flex justify-center py-24">
            <Loader2 className="w-6 h-6 animate-spin text-brand" />
          </div>
        ) : (
          <>
            <motion.h1
              data-testid="terms-title"
              initial={{ opacity: 0, y: 24 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="font-display font-black uppercase tracking-tighter text-4xl sm:text-5xl text-ink"
            >
              {page.title}
            </motion.h1>
            <p className="mt-4 font-mono text-xs tracking-[0.2em] uppercase text-black/40">{page.tagline}</p>
            <div className="mt-14 space-y-12">
              {page.sections?.map((s, i) => (
                <motion.div
                  key={i}
                  data-testid={`terms-section-${i + 1}`}
                  initial={{ opacity: 0, y: 24 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-60px" }}
                  transition={{ duration: 0.6 }}
                >
                  <h2 className="font-display font-bold text-xl text-ink">{s.heading}</h2>
                  <p className="mt-4 text-ink/65 font-light leading-relaxed whitespace-pre-line">{s.text}</p>
                </motion.div>
              ))}
            </div>
          </>
        )}
      </section>
      <Footer />
    </main>
  );
}
